import { FieldArray } from "formik";
import React, { useEffect, useState } from "react";

import { Button, FormControlLabel, Grid, IconButton, InputAdornment, Switch, TextField, Tooltip, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    portlet: {
        'box-shadow': 'none',
    },
    formControl: {
        width: '85%',
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
    },
    autoComplete: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    button: {
        margin: theme.spacing(1)
    },
    paper: {
        marginTop: theme.spacing(2),
    },
    iconButton: {
        marginTop: theme.spacing(3),
    },
    clearButton: {
        marginTop: theme.spacing(3),
        marginLeft: '10px',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    effectiveBox: {
        height: '100%',
        paddingTop: '25px'
    },
    tooltip: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        width: 400,
        border: `1px solid ${theme.palette.primary.main}`,
    },
    switch: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}));

export default function ContractLTCHSelectionCriteriaFieldArray({
    values, touched, errors, setFieldValue, disabled
}) {
    const [customErrors, setCustomErrors] = useState([]);

    const classes = useStyles();

    function getError(key, index) {
        if (errors.contractLtchConfigurationXref) {
            if (errors.contractLtchConfigurationXref[index]) {
                return errors.contractLtchConfigurationXref[index][key];
            }
            return false;
        }
        return false;
    }

    function handlePercentageChage(e, index) {
        setFieldValue(`contractLtchConfigurationXref.${index}.percentage`, e.target.value);
    }

    function handleEffectiveFromChange(e, index) {
        setFieldValue(`contractLtchConfigurationXref.${index}.effectiveFrom`, e.target.value);
        if(index > 0) {
            const previousDate = new Date(values.contractLtchConfigurationXref[index - 1].effectiveFrom);
            const currentDate = new Date(e.target.value);

            if (currentDate <= previousDate) {
                const temp = [...customErrors];
                temp[index] = 'Configuration with same date already exists. Please select different date.'
                setCustomErrors(temp);
                setFieldValue(`contractLtchConfigurationXref.${index}.customPPSError`, 'error');
            } else {
                setFieldValue(`contractLtchConfigurationXref.${index}.customPPSError`, undefined);
                const temp = [...customErrors];
                temp[index] = null
                setCustomErrors(temp);
            }
        }
        else {
            setFieldValue(`contractLtchConfigurationXref.${index}.customPPSError`, undefined);
            const temp = [...customErrors];
            temp[index] = null
            setCustomErrors(temp);
        }
    }

    function handleClearFields() {
        setFieldValue(`contractLtchConfigurationXref`, [{
            equator: '',
            value: '',
            percentage: '100',
            effectiveFrom: ''
        }]);

        setCustomErrors([]);
    }

    const renderContractLtchConfigurationXref = (remove, insert) => {
        return (
            (<Grid item xs={12}>
                {values.contractLtchConfigurationXref.map((ltchCriteria, index) =>
                    <Grid container>
                        <Grid item xs={3}>
                            <TextField
                                type="text"
                                label="Name"
                                disabled={true}
                                name={`contractLtchConfigurationXref.${index}.name`}
                                className={classes.textField}
                                margin="normal"
                                value={"LTCH"}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                type="date"
                                disabled={disabled}
                                label="Effective From"
                                name={`contractLtchConfigurationXref.${index}.effectiveFrom`}
                                className={classes.textField}
                                margin="normal"
                                value={ltchCriteria.effectiveFrom}
                                onChange={e => handleEffectiveFromChange(e, index)}
                                helperText={getError('effectiveFrom', index)}
                                error={getError('effectiveFrom', index)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                type="number"
                                disabled={disabled}
                                label="Percentage"
                                name={`contractLtchConfigurationXref.${index}.percentage`}
                                className={classes.textField}
                                margin="normal"
                                value={ltchCriteria.percentage}
                                onChange={e => handlePercentageChage(e, index)}
                                helperText={getError('percentage', index)}
                                error={getError('percentage', index)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Grid container>
                            {(index >= 0 && values.contractLtchConfigurationXref.length > 1) && (
                                <IconButton
                                    edge="start"
                                    disabled={disabled}
                                    aria-label="Delete"
                                    onClick={() => {
                                        remove(index);
                                        const temp = [...customErrors];
                                        temp[index] = null
                                        setCustomErrors(temp);
                                        setFieldValue(`contractLtchConfigurationXref.${index}.customPPSError`, undefined);
                                    }}
                                    className={classes.iconButton}
                                    size="large">
                                    <DeleteIcon />
                                </IconButton>
                            )}
                            {index === 0 && (
                                <>
                                <IconButton
                                    edge="start"
                                    disabled={disabled}
                                    color="primary"
                                    aria-label="Add"
                                    onClick={() => insert(values.contractLtchConfigurationXref.length, {
                                        effectiveFrom: '',
                                        percentage: 100,
                                    })}
                                    className={classes.iconButton}
                                    size="large">
                                    <AddCircleIcon />
                                </IconButton>
                                </>
                            )}
                            </Grid>
                        </Grid>

                    </Grid>
                )}
            </Grid>)
        );
    }

    return (
        <FieldArray
            name="contractLtchConfigurationXref"
            render={({ remove, insert }) => (
                <Grid container>
                    { renderContractLtchConfigurationXref(remove, insert) }
                </Grid>
            )}
        />
    );
}
